import avatarMale from '../assets/icons/avatar_male.svg';
import avatarFemale from '../assets/icons/avatar_female.svg';

export const getAvatarByGender = (gender: string | null | undefined) => {
  if (!gender) return avatarMale; // Default to male avatar if gender is null or undefined
  return gender.toLowerCase() === 'male' ? avatarMale : avatarFemale;
};